import type { CourseModule } from "@/core/types";
import { lektionAufbau } from "./lektion-01-aufbau";
import { lektionBereiche } from "./lektion-02-bereiche";
import { lektionAnsicht } from "./lektion-03-ansicht";

export const modulGrundlagen: CourseModule = {
  id: "grundlagen",
  title: "Arbeitsmappe, Blätter und Bereiche",
  summary:
    "Wie eine Arbeitsmappe aufgebaut ist, in welcher Form Daten hineingehören – " +
    "und wie man sich darin bewegt, ohne zu scrollen.",
  level: "Grundlagen",
  lessons: [lektionAufbau, lektionBereiche, lektionAnsicht],
};
